var exports = {
  "y": "x112a1f60--c80002--links",
  "n": "x112a1f60--c80002--link",
};

module.exports = exports;
